// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--T5xz5","item":"styles-module__item--Sqe6s","active":"styles-module__active--cPTMr"};